// @flow
export const Pattern1: 'Pattern1' = 'Pattern1';
export const Pattern2: 'Pattern2' = 'Pattern2';
export const Pattern3: 'Pattern3' = 'Pattern3';
